
// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data('languageDialog', function () {
    return {
      show: false,
      regions: [],
      loading: false,

      init() {
        this.regions = this.$store.localization.regions
        subscribe(PUB_SUB_EVENTS.languageDialog, (event) => {
          if (event.data.show) {
            this.open()
          } else {
            this.closed()
          }
        });
      },
      open() {
        this.show = true
        document.body.style.overflow = 'hidden'
      },
      closed() {
        this.show = false
        document.body.style.overflow = ''
      },

      async handleLanguage(item) {
        // const form = document.querySelector('#languageDialogLocalizationForm')
        // const country_code = form.querySelector('input[name="country_code"]')
        // const locale_code = form.querySelector('input[name="locale_code"]')
        // const submit = form.querySelector('input[name="submit"]')
        // country_code.value = item.country_code
        // locale_code.value = item.language_code
        try {
          this.loading = true
          setTimeout(() => {
            this.loading = false
          }, 30000)
          await this.$store.localization.setLang(item)
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false
        }

        // setTimeout(() => {
        //   submit.click()
        // })
      },

      dialogSearchForm: {
        search: ""
      },
      searchLanguageList: [],
      searchLanguageListShow: false,

      languageSearch() {
        this.searchLanguageListShow = true
        const arr = []
        for (const property in this.regions) {
          const languages = this.regions[property].languages
          for (let i = 0; i < languages.length; i++) {
            arr.push(languages[i])
          }
        }
        const str = this.dialogSearchForm.search
        const test = this.searchStr(str, arr)
        this.searchLanguageList = test
      },
      searchStr(str, arr) {
        const newList = []
        // 要匹配字符串的首个字符
        const startChar = str.charAt(0)
        // 要匹配字符串的字符长度
        const strLength = str.length
        for (let i = 0; i < arr.length; i++) {
          // 默认数组arr中对象arr[i]不存在str
          let isExist = false
          const obj = arr[i]
          for (const key in obj) {
            if (typeof obj[key] === 'function') {
              obj[key]()
            } else {
              let keyValue = ''
              // 获取arr[i][key]的值
              if (obj[key] !== null && typeof obj[key] === 'string') {
                keyValue = obj[key]
              } else if (obj[key] !== null && typeof obj[key] !== 'string') {
                keyValue = JSON.stringify(obj[key])
              }
              // arr[i][key]中的各个位置的字符与str的0位置字符startChar对比如果相等，
              // 在arr[i][key]中从j位置截取与str长度相同的字符，对比是否相等
              for (let j = 0; j < keyValue.length; j++) {
                // 把原有数据转化为小写，输入数据也转化为纯小写，实现模糊匹配,如区分大小写，可删除toLowerCase()
                if (
                  keyValue.charAt(j).toLowerCase() === startChar.toLowerCase()
                ) {
                  if (
                    keyValue
                      .substring(j)
                      .substring(0, strLength)
                      .toLowerCase() === str.toLowerCase()
                  ) {
                    // 模糊匹配到的字符存在表示arr[i]中存在str
                    isExist = true
                    break
                  }
                }
              }
            }
          }
          // 当arr[i]中存在str时，把arr[i]放入一个新数组
          if (isExist === true) {
            newList.push(obj)
          }
        }
        // 最后返回这个新数组
        return newList
      }
    }
  })
}

document.addEventListener('alpine:init', main)
